module.exports = __webpack_public_path__ + "static/media/left.db3726ae.svg";